 $("#loading-overlay").css("display", "block");


//initialize aws for photos
var albumBucketName = 'hangoutlighting-visualizerphoto';
var bucketRegion = 'us-east-1';
var IdentityPoolId = 'us-east-1:6868ab1b-fa31-4a32-a200-96408bea1b2f';

AWS.config.update({
    region: bucketRegion,
    credentials: new AWS.CognitoIdentityCredentials({
        IdentityPoolId: IdentityPoolId
    })
});

var s3 = new AWS.S3({
    apiVersion: '2006-03-01',
    params: {
        Bucket: albumBucketName
    }
});

//end aws initialize

function urlParam(name) {
  const match = new RegExp('[?&]' + name + '=([^&#]*)').exec(location.href);
  return match ? match[1] : null;          // leave raw, we'll decode later
}
var isMobile = false; //initiate as false
// device detection
if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) ||
    /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
    isMobile = true;
}
var mobileProductChange = false;
var threekitQueue = []
var threekitExecuting = false;
var threekitdata = new Object;
var getthreekitdata = urlParam('configurator.configuration');
var boldDefaultOptions = new Object;
var threekitDefaultOptions = new Object;
var trueBoldArray = new Object;
var loadedFlag = false;
var threekitloaded = false;
var threekitOptionArray = new Object; //array of configuration parameters

var mythreekitstring = "";
var longlink = ""; //link with current config parameters
var currentThreeAttr ="Product";

function testFunction(finishAttr) {
  if(finishAttr == "Extras"){
    $("#loading-overlay").css("display", "none");
  }

  if (currentThreeAttr == finishAttr){
    threekitExecuting = false;

    if (threekitQueue[0] == undefined) {

        if (isMobile && mobileProductChange) {
            mobileProductChange = false;
            var cameraId = api.scene.find('Camera_2');
            api.player.animateCameraTo(cameraId, 1).then(function() {
                api.player.frameScene();
            })
            $("#loading-overlay").css("display", "none");
           $(".loading-container").css("display", "none");
           $('.jquery-modal').click();
        } else {
        
          
            $("#loading-overlay").css("display", "none");
           $(".loading-container").css("display", "none");
          $('.jquery-modal').click();
        }
        writeDescription();
        getImages();
         const price = api.configuration.generatePrice("all",1,"mm");
      if( price && typeof price === 'number'){
let elements = document.getElementsByClassName('product-price');

for(let i = 0; i < elements.length; i++){
    elements[i].innerText = '$' + price;
}
      } else {
        let elements = document.getElementsByClassName('product-price');

for(let i = 0; i < elements.length; i++){
    elements[i].innerText = 'Pricing not available right now.  Contact us for a quote.';
}
      }


      



    } else {
        checkFlag();
    }
  }
}

function checkFlag() {
    if (threekitExecuting == false && threekitQueue[0] !== undefined && threekitloaded) {

        threekitExecuting = true;
        var tempOBJ = new Object;
        tempOBJ = threekitQueue[0];

        var attr = Object.keys(tempOBJ)[0]
        var val = Object.values(tempOBJ)[0];
        threekitQueue.splice(0, 1);

        var curConfig = api.configuration.getConfiguration();

        if (curConfig[attr] !== val ) {
            if (attr == "Product" || attr.includes("Length")) {

                mobileProductChange = true;
            }
      
      
          currentThreeAttr = attr;
                api.configuration.executeAttribute(attr, val);

        } else {

            threekitExecuting = false;
         
            if (threekitQueue[0] == undefined) {
                if (isMobile && mobileProductChange) {
                    mobileProductChange = false;
                    var cameraId = api.scene.find('Camera_2');
                    api.player.animateCameraTo(cameraId, 1).then(function() {
                        api.player.frameScene();
                    })
                    $("#loading-overlay").css("display", "none");
                  
                  $('.jquery-modal').click();
                } else {
                    $("#loading-overlay").css("display", "none");
                 
                 $('.jquery-modal').click();
                }
                writeDescription();
               getImages();
                       const price = api.configuration.generatePrice("all",1,"mm");
        if( price && typeof price === 'number'){
        let elements = document.getElementsByClassName('product-price');

        for(let i = 0; i < elements.length; i++){
          elements[i].innerText = '$' + price;
        }
        } else {
        let elements = document.getElementsByClassName('product-price');

        for(let i = 0; i < elements.length; i++){
          elements[i].innerText = 'Pricing not available right now.  Contact us for a quote.';
        }
      }


              
              
            } else {
              checkFlag();
            }
        }

    }
}

function writeDescription() {
    document.getElementById("product-description-bottom").innerHTML = api.configuration.generateDescription();


}

  function toTitleCase(str) {
    return str.replace(/\w\S*/g, function(txt){
      if (txt!= "x"){
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      }else{
        return txt;
      }
      });
  }


function getImages() {

var params = { 
 Bucket: 'install-photos-mm',
 Delimiter: '/',
 Prefix: ''
}
  //console.log("about to ask");
const s3DataList = s3.listObjects(params, function (err, data) {
  var imageList=[];
 if(err)throw err;
  //console.log("asked");
   Object.keys(data.Contents).forEach(function(key) {
    imageList.push(data.Contents[key].Key);
   });
  //console.log(imageList);
var finalImages = api.configuration.generateInspiration(imageList) ; 
  $('.thumbnails').empty();
for (let key in finalImages) {
  var productString = JSON.stringify(finalImages[key].product, removeEmptyStrings, 2);
  var link = document.createElement("a");
  link.href = "#";
  link.setAttribute("data-target","#ex2");
  link.setAttribute("data-toggle","modal");
  link.setAttribute("class","imageLink");
  link.setAttribute("style","padding:10px;");
      var thumbnail = document.createElement("button");
    thumbnail.setAttribute("class", "thumbnails__img");
  thumbnail.setAttribute("type", "button");
    thumbnail.setAttribute("data-img-src", finalImages[key].url);
     thumbnail.setAttribute("data-product-single-thumbnail", "");
  thumbnail.setAttribute("style", "background-image: url( '"+finalImages[key].url+"' );");
thumbnail.setAttribute("data-img-product", productString);
 link.append(thumbnail);
  $(".thumbnails").append(link);





   
  
}
   setTimeout(redoSticky, 2000);
  //console.log(finalImages);
  function isOdd(x) { return x & 1; };
  function getKeyByValue(object, value) {
    if (isNaN(value)){
  return Object.keys(object).find(key => object[key] === value);
    }
    else {
      return Object.keys(object).find(key => object[key] === Number(value));
    }
};
});
  }
function redoSticky() {
   if ($(window).width() > 767) {
            $('#slidersticky')
                .on('sticky_kit:bottom', function(e) {
                    $(this).parent().css('position', 'static');
                })
                .on('sticky_kit:unbottom', function(e) {
                    $(this).parent().css('position', 'relative');
                })
        }
}
function removeEmptyStrings(key, value) {
  if (value === '') {
    return undefined;
  }
  return value;
}



function boldOverwrite(attr, val, imageApply) {

    $.each(trueBoldArray, function(key, valueObj) {
        var boldAttrName = trueBoldArray[key].publicName.replace("*", "").replace(/[0-9]/g, '').trim();
	

        if (boldAttrName == attr) {
          
          

            trueBoldArray[key].needsOverwrite = true;
            


            var optionType = trueBoldArray[key].minitype;

            if (optionType == "sw") {
                var tempArray = [];
                tempArray[0] = val;
                trueBoldArray[key].loadValue = tempArray;
            } else if (optionType == "dd") {
                trueBoldArray[key].loadValue = val;
            }
            if(imageApply){
 setTimeout(function() {
            if(trueBoldArray[key].DOM.visible){
              $("#loading-overlay").css("display", "block");

  
             
                  trueBoldArray[key].receiveValue(trueBoldArray[key].loadValue);
            }
                }, 0);
            }
              
             

              
             // $.each(trueBoldArray[key].optionValues, function(option, optionValue) {
               // if (trueBoldArray[key].optionValues[option].name == val &&  trueBoldArray[key].optionValues[option].selected == false){
                  //console.log(trueBoldArray[key]);
             
                  //console.log("Sent val : " + val + " to receive values");
                 // console.log(trueBoldArray[key].loadValue);
                //}
              //});
               
            }
        
        




    });
    if(imageApply){
     

                var tempOBJ = new Object;
                tempOBJ[attr] = val;
              
                threekitQueue.push(tempOBJ);
                checkFlag();
   
    }
      


}



const checkBoldLoaded = setInterval(function() {
    if (window.BOLD?.options?.app) {
        // BOLD object is now available, proceed with your code
        console.log('BOLD is loaded:', BOLD);
        
        // Clear the interval to stop checking
        clearInterval(checkBoldLoaded);


BOLD.options.app.on('option_changed', function(data) {

    var changeflag = 0;
    var changeOption = data.data.option;

    //create default object  Correct
    if (loadedFlag == false && data.data.value !== "") {

        var a = changeOption.publicName;
        var v = changeOption;
        var optionType = changeOption.minitype;

        if (optionType == "sw") {
            v["dValue"] = data.data.value[0];
        } else if (optionType == "dd") {
            v["dValue"] = data.data.value;

        }
        boldDefaultOptions[a] = v;
    }



    setTimeout(function() {
        var attr = changeOption.publicName.replace("*", "").replace(/[0-9]/g, '').trim();

        if (attr == "Cage / Shade") {

        }
              if (attr == "Ceiling Hooks" && !threekitloaded && changeOption.dValue != changeOption.loadValue && changeOption.loadValue && changeOption["needsOverwrite"] == true  ) {
            changeOption.receiveValue(changeOption.loadValue);
        }
        //if a condition is causing a change and the change needs an overwrite of nonNull then we push that overwrite value
        if (data.data.source == "condition" && threekitloaded == true && changeOption["needsOverwrite"] == true && changeOption.loadValue != data.data.value && changeOption.DOM.visible == true && changeOption.loadValue && attr.toLowerCase().indexOf("length") === -1 && threekitloaded == true && loadedFlag == true) {

            $.each(changeOption.optionValues, function(key, value) {
                if (changeOption.optionValues[key].name == changeOption.loadValue) {
                    changeOption["needsOverwrite"] = false;
                    changeOption.receiveValue(changeOption.loadValue);
                    if (attr == "Bulb" || attr == "Shade" || attr == "Cage" || attr == "Shade Fitter") {

                        var tempOBJ = new Object;
                        tempOBJ[attr] = String(changeOption.loadValue);
                        threekitQueue.push(tempOBJ);

                        checkFlag();

                    }
                    changeflag = 1;
                    return false;
                } else {

                    changeflag = 2;
                }
            });
            if (changeflag == 2 && attr.toLowerCase().indexOf("length") === -1) {
                //couldn't find overwrite option
                var optionType = changeOption.minitype;
                var val = "None";
                if (data.data.value != "") {
                    if (optionType == "sw") {
                        val = data.data.value[0];
                    } else if (optionType == "dd") {
                        val = data.data.value;
                    }
                }
                //There is default and we can't override.  Sync to threekit
                var tempOBJ = new Object;
                tempOBJ[attr] = val;
                threekitQueue.push(tempOBJ);
                checkFlag();


                if (data.data.value != "" || attr == "Bulb") {
                    boldOverwrite(attr, val);
                }
            }
            changeflag = 0;
        } else if (threekitloaded == true && data.data.source == "condition" && attr == "Cage / Shade") {
            //Syncing cage / shade after clusters are chosen and then something else
            var attrib = api.configuration.getAttribute("Cage / Shade");
            if ((!attrib || attrib.defaultValue == "None") && data.data.value[0] != "None") {
                changeOption.receiveValue("None");
            }
        }
        if ($(window).width() > 767) {

            $(document.body).trigger("sticky_kit:recalc");
        }
    }, 100);
});

BOLD.options.app.on('option_products_loaded', function(data) {
    var usingGet = false;
setTimeout(function() {
  
   if (getthreekitdata == null){
              
               var script_tag = document.getElementById('threekitMasterScript');
              
               var objectString = decodeURI(script_tag.getAttribute("data-object")).replace(/\+/g, ' ').replace(/%2C/g,",").replace(/[\[\]']+/g,'').replace(/\"/g, "");

              var objectArr = objectString.split(","); 

              var finalObject = {};
     
for (let i = 0; i < objectArr.length; i++) {
  let val = objectArr[i];
  let optionArr = val.split('-');
  let attrVal;

  if (optionArr.length > 2) {
    attrVal = toTitleCase(optionArr.slice(2).join('-').trim().replace(/\\\\\\/g, '"'));
  } else {
    attrVal = toTitleCase(optionArr[2]).replace(/\\\\\\/g, '"');
  }

  attrVal = attrVal.replace('Xl', 'XL');
  attrVal = attrVal.replace('Ufo', 'UFO');
  let attr;

  if (optionArr[1] === "nop") {
    attr = "Number of Pendants";
  } else if (optionArr[1] === "cageshade") {
    attr = "Cage / Shade";
  } else {
    attr = toTitleCase(optionArr[1]);
    attr = attr.replace('feet', 'Feet');
  }

  finalObject[attr] = attrVal.replace('Led', 'LED');
}

     
     if(!finalObject['Socket']){
     	finalObject['Socket'] = "Modern Black";
     }
          if(!finalObject['Bulb']){
     	finalObject['Bulb'] = 'LED 5" Globe';
     }
            	getthreekitdata = JSON.stringify(finalObject);
				//console.log(getthreekitdata);
                      
          }
  
  //causes issue without timeout for render.  Not sure why - Issue Round/twisted logic doesnt function with swag chandelier load.
        //Load all load values from after creation
        trueBoldArray = data.data.option_products[0].optionSets[0].options;

        //create threekitDefaultOptions;
  
        if (boldDefaultOptions) {
           for (var k in boldDefaultOptions) {
  var v = boldDefaultOptions[k];

  if (v.DOM.visible) {
    var threek = k.replace(/[*0-9]/g, '').trim();
    if (threek === "Bulb") {
    
    
    }
    threekitDefaultOptions[threek] = v.dValue;
  }
}
        }

// if using get data parse it before the bold loop
 if (getthreekitdata != null) {

                usingGet = true;
   const decoded  = decodeURIComponent(getthreekitdata.replace(/\+/g, ' '));

                threekitdata = JSON.parse(decoded);
 };

  
//for (var key = 0; key < trueBoldArray.length; key++) {
 // trueBoldArray[key].continueConditionalLogic = true;
//}
             
       for (var key = 0; key < trueBoldArray.length; key++) {

            trueBoldArray[key].continueConditionalLogic = true;
            trueBoldArray[key]["loading"] = false;
            trueBoldArray[key]["needsOverwrite"] = true;
            var boldAttrName = trueBoldArray[key].publicName.replace("*", "").replace(/[0-9]/g, '').trim();
            // if get data exists assign load values from get data

            if (getthreekitdata != "empty") {
                $.each(threekitdata, function(threeAttr, value) {
                    if (boldAttrName == threeAttr) {

                        if (trueBoldArray[key].minitype == "dd") {
                            trueBoldArray[key]["loadValue"] = value;
                        } else if (trueBoldArray[key].minitype == "sw") {
                            var tempArray = [];
                            tempArray[0] = value;
                            trueBoldArray[key]["loadValue"] = tempArray;
                        }
                    }
                });
            }
            //assign load values from default Bold Options
            else if (threekitDefaultOptions != "") {

               for (let k in threekitDefaultOptions) {
  if (k === boldAttrName && boldAttrName !== "Number of Pendants") {
    let optionType = trueBoldArray[key].minitype;

    if (optionType === "dd") {
      trueBoldArray[key]["loadValue"] = threekitDefaultOptions[k];
    } else if (optionType === "sw") {
      let tempArray = [threekitDefaultOptions[k]];
      trueBoldArray[key]["loadValue"] = tempArray;
    }
  }
}
                if (boldAttrName == "Number of Pendants") {
              
                    trueBoldArray[key]["loadValue"] = trueBoldArray[key]["dValue"];
                }
            }
        }

        //load initial values  
       for (var key = 0; key < trueBoldArray.length; key++) {
            if (trueBoldArray[key].loadValue) {
                var changeFlag = false;
                $.each(trueBoldArray[key].optionValues, function(key1, value1) {
                    if (trueBoldArray[key].optionValues[key1].name == trueBoldArray[key].loadValue) {
                        changeFlag = true;
                        return false;
                    }
                });
                if (changeFlag == true) {
                    setTimeout(function(option) {
                        option.receiveValue(option.loadValue);
                    }, 0, trueBoldArray[key]);

                }
            }
        }
        //asssigning number of pendant defaults if loading from get data - REMOVED because on initial load if you change product it will have wrong NOP on visualizer
        //if (usingGet == true) {
          //  setTimeout(function() {
          //      $.each(trueBoldArray, function(key, value) {
           //         var thisAttrName = trueBoldArray[key].publicName.replace("*", "").replace(/[0-9]/g, '').trim();
           //         if (thisAttrName == "Number of Pendants") {
         //               //trueBoldArray[key]["loadValue"] = trueBoldArray[key]["dValue"];
           //         }
              //  });
           // }, 100);
       // }
        loadedFlag = true;
},100);
});

BOLD.options.app.on('options_loaded', function(data) {
  console.log("WE LOADING");
    var loadedData = data.data.option_product.optionSets[0].options;
  console.log(loadedData);
    $(".bold_option_title").each(function() {
      console.log($(this));
        var title = $(this).text().replace(/\d+/g, '');
        $(this).text(title);
      switch (title.replace(/\*/g, '').replace(/\s/g, '')) {
                       case "CordType":
             $(this).next().find('.bold_option_value_swatch').css({width:'150px',height:'44px'});
            break;
            case "Socket":
		  var mtContainer = document.createElement('div');
          var vContainer = document.createElement('div');
          var mContainer = document.createElement('div');
          var kContainer = document.createElement('div');
          var tContainer = document.createElement('div');
          var wContainer = document.createElement('div');
 		  var myH4V = document.createElement('h4');
          var myH4M = document.createElement('h4');
          var myH4K = document.createElement('h4');
          var myH4T = document.createElement('h4');
          var myH4MT = document.createElement('h4');
           var myH4W = document.createElement('h4');
		  $(myH4V).text("Vintage Sockets");
          $(myH4M).text("Modern Sockets");
          $(myH4K).text("Keyed(on/off) Sockets");
          $(myH4T).text("Vintage Threaded Sockets");
          $(myH4MT).text("Modern Threaded Sockets");
          $(myH4W).text("Wood Sockets");
          myH4V.className = "subTitle";
          myH4M.className = "subTitle";
          myH4K.className = "subTitle";
          myH4T.className = "subTitle";
          myH4MT.className = "subTitle";
          myH4W.className = "subTitle";
     	  vContainer.append(myH4V);
          mContainer.append(myH4M);
          kContainer.append(myH4K);
          tContainer.append(myH4T);
          mtContainer.append(myH4MT);
          wContainer.append(myH4W);
          $(this).siblings('.bold_option_element:first').children('.bold_option_value').each(function () { 
  		  var value = $(this).find('input')[0].value;
          if (value.indexOf('Wood') >= 0) {
           $(this).appendTo(wContainer); 
          }
          else if (value.indexOf('Modern Threaded') >= 0){
           $(this).appendTo(mtContainer); 
          }
          else if (value.indexOf('Threaded') >= 0){
           $(this).appendTo(tContainer); 
          }
          else if (value.indexOf('Keyed') >= 0){
           $(this).appendTo(kContainer); 
          }
          else if (value.indexOf('Modern') >= 0){
           $(this).appendTo(mContainer); 
          }
          else if (value.indexOf('Vintage') >= 0){
           $(this).appendTo(vContainer); 
          }
           
    });
         if (vContainer.children[1]) $(this).nextAll('.bold_option_element').append(vContainer);
          if (mContainer.children[1]) $(this).nextAll('.bold_option_element').append(mContainer);
          if (kContainer.children[1]) $(this).nextAll('.bold_option_element').append(kContainer);
          if (wContainer.children[1]) $(this).nextAll('.bold_option_element').append(wContainer);
          if (tContainer.children[1]) $(this).nextAll('.bold_option_element').append(tContainer);
          if (mtContainer.children[1]) $(this).nextAll('.bold_option_element').append(mtContainer);
          
          
    var a = document.createElement('a');
    a.href =  '/collections/sockets'; // Insted of calling setAttribute 
    a.innerHTML = "<i class=\"far fa-question-circle\"></i>"; // <a>INNER_TEXT</a>
    a.target="_blank";
    a.setAttribute("class", "helplink"); 
    $(this).after(a); 
    break;
  case "Bulb":
          var amberContainer = document.createElement('div');
          var clearContainer = document.createElement('div');
          var whiteContainer = document.createElement('div');
          var smokeContainer = document.createElement('div');
          var dippedContainer = document.createElement('div');
 		  var myH4Amber = document.createElement('h4');
          var myH4Clear = document.createElement('h4');
          var myH4White = document.createElement('h4');
          var myH4Smoke = document.createElement('h4');
          var myH4Dipped = document.createElement('h4');
		  $(myH4Amber).text("Amber Bulbs");
          $(myH4Clear).text("Clear Bulbs");
          $(myH4White).text("White Bulbs");
          $(myH4Smoke).text("Smoke Bulbs");
          $(myH4Dipped).text("Dipped Bulbs");
          myH4Amber.className = "subTitle";
          myH4Clear.className = "subTitle";
          myH4White.className = "subTitle";
          myH4Smoke.className = "subTitle";
          myH4Dipped.className = "subTitle";
     	  amberContainer.append(myH4Amber);
          clearContainer.append(myH4Clear);
          whiteContainer.append(myH4White);
          smokeContainer.append(myH4Smoke);
          dippedContainer.append(myH4Dipped);
       
  		  $(this).siblings('.bold_option_element:first').children('.bold_option_value').each(function () { 
  		  var value = $(this).find('input')[0].value;
          if (value.indexOf('Clear') >= 0) {
           $(this).appendTo(clearContainer); 
          }
          else if (value.indexOf('White') >= 0){
           $(this).appendTo(whiteContainer); 
          }
          else if (value.indexOf('Smoke') >= 0){
           $(this).appendTo(smokeContainer); 
          }
          else if (value.indexOf('Dipped') >= 0){
           $(this).appendTo(dippedContainer); 
          }
          else {
           $(this).appendTo(amberContainer); 
          }
           
    });
    if (amberContainer.children[1]) $(this).nextAll('.bold_option_element').append(amberContainer);
     if (clearContainer.children[1]) $(this).nextAll('.bold_option_element').append(clearContainer);
      if (whiteContainer.children[1]) $(this).nextAll('.bold_option_element').append(whiteContainer);
      if (smokeContainer.children[1]) $(this).nextAll('.bold_option_element').append(smokeContainer);
      if (dippedContainer.children[1]) $(this).nextAll('.bold_option_element').append(dippedContainer);
          
               var a = document.createElement('a');
    a.href =  '/collections/lamps'; // Insted of calling setAttribute 
    a.innerHTML = "<i class=\"far fa-question-circle\"></i>"; // <a>INNER_TEXT</a>
    a.target="_blank";
    a.setAttribute("class", "helplink"); 
    $(this).after(a); 
    break;
          case "Cage":

               var a = document.createElement('a');
    a.href =  '/collections/shade'; // Insted of calling setAttribute 
    a.innerHTML = "<i class=\"far fa-question-circle\"></i>"; // <a>INNER_TEXT</a>
    a.target="_blank";
    a.setAttribute("class", "helplink"); 
    $(this).after(a); 
    break;
                    case "Shade":


          var metalContainer = document.createElement('div');
          var glassContainer = document.createElement('div');
          var feltContainer = document.createElement('div');
          var wireContainer = document.createElement('div');
          var bambooContainer = document.createElement('div');

          var myH4Metal = document.createElement('h4');
          var myH4Glass = document.createElement('h4');
          var myH4Felt = document.createElement('h4');
          var myH4Wire = document.createElement('h4');
          var myH4Bamboo = document.createElement('h4');

          $(myH4Metal).text("Metal");
          $(myH4Glass).text("Glass Shades");
          $(myH4Felt).text("Felt Shades");
          $(myH4Wire).text("Wire Frame Shades");
          $(myH4Bamboo).text("Woven Bamboo Shades");

          myH4Metal.className = "subTitle";
          myH4Glass.className = "subTitle";
          myH4Felt.className = "subTitle";
          myH4Wire.className = "subTitle";
          myH4Bamboo.className = "subTitle";

          metalContainer.append(myH4Metal);
          glassContainer.append(myH4Glass);
          feltContainer.append(myH4Felt);
          wireContainer.append(myH4Wire);
          bambooContainer.append(myH4Bamboo);
       
  		  $(this).siblings('.bold_option_element:first').children('.bold_option_value').each(function () { 
  		  var value = $(this).find('input')[0].value;
          if (value.indexOf('Felt') >= 0) {
           $(this).appendTo(feltContainer); 
          }
          else if (value.indexOf('Glass') >= 0 || value.indexOf('Neckless') >=0){
           $(this).appendTo(glassContainer); 
          }
          else if (value.indexOf('Cage') >= 0){
           $(this).appendTo(wireContainer); 
          }
          else if (value.indexOf('Bamboo') >= 0){
           $(this).appendTo(bambooContainer); 
          }
          else {
           $(this).appendTo(metalContainer); 
          }

           
    });

    $(this).nextAll('.bold_option_element').append(metalContainer);
    $(this).nextAll('.bold_option_element').append(glassContainer);
    $(this).nextAll('.bold_option_element').append(feltContainer);
    $(this).nextAll('.bold_option_element').append(wireContainer);
    $(this).nextAll('.bold_option_element').append(bambooContainer);
          
               var a = document.createElement('a');
    a.href =  '/collections/shade'; // Insted of calling setAttribute 
    a.innerHTML = "<i class=\"far fa-question-circle\"></i>"; // <a>INNER_TEXT</a>
    a.target="_blank";
    a.setAttribute("class", "helplink"); 
    $(this).after(a); 
    break;
          case "CeilingPlate":
          
          var metalContainer = document.createElement('div');
          var woodContainer = document.createElement('div');

          var myH4Metal = document.createElement('h4');
          var myH4Wood = document.createElement('h4');


          $(myH4Metal).text("Metal Ceiling Plates");
          $(myH4Wood).text("Wood Ceiling Plates");


          myH4Metal.className = "subTitle";
          myH4Wood.className = "subTitle";


          metalContainer.append(myH4Metal);
          woodContainer.append(myH4Wood);

       
  		  $(this).siblings('.bold_option_element:first').children('.bold_option_value').each(function () { 
  		  var value = $(this).find('input')[0].value;
          if (value.indexOf('Wood') >= 0) {
           $(this).appendTo(woodContainer); 
          }

          else {
           $(this).appendTo(metalContainer); 
          }

           
    });

    $(this).nextAll('.bold_option_element').append(metalContainer);
    $(this).nextAll('.bold_option_element').append(woodContainer);

          

          
          break;
                case "Product":
          var modularContainer = document.createElement('div');
          var metalContainer = document.createElement('div');
          var woodContainer = document.createElement('div');
          var clusterContainer = document.createElement('div');
          var sconceContainer = document.createElement('div');
          var myH4Modular = document.createElement('h4');
          var myH4Metal = document.createElement('h4');
          var myH4Wood = document.createElement('h4');
          var myH4Cluster = document.createElement('h4');
		var myH4Sconce = document.createElement('h4');

          $(myH4Modular).text("Modular Chandeliers");
          $(myH4Cluster).text("Cluster Chandeliers");
          $(myH4Wood).text("Wood Chandeliers");
          $(myH4Metal).text("Metal Base Chandeliers");
           $(myH4Sconce).text("Wall Sconces");
          myH4Cluster.className = "subTitle";
           myH4Wood.className = "subTitle";
          myH4Metal.className = "subTitle";
 			myH4Sconce.className = "subTitle";
          myH4Modular.className = "subTitle";
 
          clusterContainer.append(myH4Cluster);
          metalContainer.append(myH4Metal);
        woodContainer.append(myH4Wood);
          sconceContainer.append(myH4Sconce);
          modularContainer.append(myH4Modular);
          $(this).siblings('.bold_option_element:first').children('.bold_option_value').each(function () { 
        var value = $(this).find('input')[0].value;
        if (value.indexOf('Wood Chandelier') >= 0) {
          $(this).appendTo(woodContainer); 
        }
                    else if (value.indexOf('Cluster Chandelier') >= 0) {
          $(this).appendTo(clusterContainer); 
        }
            else if (value.indexOf('Wall Sconce') >= 0) {
          $(this).appendTo(sconceContainer); 
        }
            else if (value.indexOf('Metal Chandelier') >= 0) {
          $(this).appendTo(metalContainer); 
        }
            else if (value.indexOf('Modular Chandelier') >= 0) {
          $(this).appendTo(modularContainer); 
        }
           
      });
      $(this).nextAll('.bold_option_element').append(woodContainer);
          $(this).nextAll('.bold_option_element').append(metalContainer);
          $(this).nextAll('.bold_option_element').append(modularContainer);
         $(this).nextAll('.bold_option_element').append(clusterContainer); 
            $(this).nextAll('.bold_option_element').append(sconceContainer); 
          
          
          break;
}
          
    });
 
  
  
});
          }
}, 5);
$(document).ready(function() {
    var clipboard = new ClipboardJS('#copy-btn')
    if (getthreekitdata != null) {
         
  
   const decoded  = decodeURIComponent(getthreekitdata.replace(/\+/g, ' '));

                threekitdata = JSON.parse(decoded);
    } else if (threekitDefaultOptions != "") {
        threekitdata = threekitDefaultOptions;
    }



    api.on('rendered', () => {
        threekitloaded = true;
        $("#loading-overlay").css("display", "none");
        if ($(window).width() > 767) {
            $("#slidersticky").stick_in_parent({
                parent: "#parent"
            });
            $('#slidersticky')
                .on('sticky_kit:bottom', function(e) {
                    $(this).parent().css('position', 'static');
                })
                .on('sticky_kit:unbottom', function(e) {
                    $(this).parent().css('position', 'relative');
                })
        }
    });

    api.configuration.onChange(function() {
        threekitOptionArray = api.configuration.getConfiguration();
        mythreekitstring = JSON.stringify(threekitOptionArray);
        longlink = "https://" + window.location.hostname + window.location.pathname + "?configurator.configuration=" + mythreekitstring;
        $("#customlinkinput").val(longlink);
    });


//Start inspiration photo script
  
let currentImageIndex;
$('.thumbnails').on("click", '.imageLink', function() {
    $('.modalImage').attr('src', $(this).find(">:first-child").attr('data-img-src'));
   $('.modalImage').attr('data-img-Product', $(this).find(">:first-child").attr('data-img-product'));
  currentImageIndex = $(this).index();
});
  $("#arrowLeft").click(function () {
        showPrevImage();
    });
   $("#arrowRight").click(function () {
        showNextImage();
    });

document.onkeydown = function(e) {
  if ( $("#ex2").is(":visible")) {
    switch(e.which) {
        case 37: // left
          showPrevImage();
        break;
        case 39: // right
          showNextImage();
        break;
        default: return; // exit this handler for other keys
    }
    }
    //e.preventDefault(); // prevent the default action (scroll / move caret)
};

    function showPrevImage() {
        currentImageIndex = (currentImageIndex - 1 + 10) % 10;
       const imgSrc = $($(".thumbnails").children().get(currentImageIndex)).find(".thumbnails__img").data("img-src");
      const imgProduct = $($(".thumbnails").children().get(currentImageIndex)).find(".thumbnails__img").data("img-product");
       $('.modalImage').attr("src", imgSrc);
      $('.modalImage').attr("data-img-product", JSON.stringify(imgProduct)); // stringify the object before setting the attribute
    }

    // Go to the next image
    function showNextImage() {
        currentImageIndex = (currentImageIndex + 1 + 10) % 10;
        const imgSrc = $($(".thumbnails").children().get(currentImageIndex)).find(".thumbnails__img").data("img-src");
      const imgProduct = $($(".thumbnails").children().get(currentImageIndex)).find(".thumbnails__img").data("img-product");
  
       $('.modalImage').attr("src", imgSrc);
       $('.modalImage').attr("data-img-product", JSON.stringify(imgProduct)); // stringify the object before setting the attribute
    }
//Applying config on click
    $('#image-description').on('click', '#applyConfig', function() {

      // Get the img element
      var imgElement = $(this).parent().siblings('.modalImage');

      // Get the data-img-product attribute value as a string
      var imgProductDataString = imgElement.attr('data-img-product');

      var product = jsonObject = JSON.parse(imgProductDataString);
      //api.configuration.setConfiguration(product);
      for (let key in product) {
        if (key == "Number of Pendants" && product[key] == 1){
        //console.log("Number of pendants = " + product[key]);
        }
          
        else {
          boldOverwrite(key, product[key],true);
        }
      }
    
    });



  
//end inspiration photo script


  
    //converts canvas data to blob
    function dataURItoBlob(dataURI) {
        var binary = atob(dataURI.split(',')[1]);
        var array = [];
        for (var i = 0; i < binary.length; i++) {
            array.push(binary.charCodeAt(i));
        }
        return new Blob([new Uint8Array(array)], {
            type: 'image/jpeg'
        });
    }



    $("#copy-btn").click(function() {
        copytext($("#text-link").text(), this);
        $("#copy-btn").text("Copied!");
    });

    function copytext(text, context) {
        var textField = document.createElement('textarea');
        textField.innerText = text;

        if (context) {
            context.parentNode.insertBefore(textField, context);
        } else {
            document.body.appendChild(textField);
        }

        textField.select();
        document.execCommand('copy');
        // Let `.remove()` also work with older IEs
        textField.parentNode.removeChild(textField);
    }

    $("#save").click(function() {
        $("#ex1").modal()
        $("#copy-btn").text("Copy Link to Clipboard");
        $(".modal-overlay").css("display", "block");
        $("#text-link").text("");
        $("#copy-btn").attr("data-clipboard-text", "");


        let linkRequest = {
            destination: encodeURI(longlink),
            domain: {
                fullName: "configuration.mixmatchlighting.com"
            }
            //, slashtag: "A_NEW_SLASHTAG"
            //, title: "Rebrandly YouTube channel"
        }

        let requestHeaders = {
            "Content-Type": "application/json",
            "apikey": "f58740a12c124e31a5a7dfc03460d355",
            "workspace": "c33ba0543cd84fb79519f1383846254a"
        }

        $.ajax({
            url: "https://api.rebrandly.com/v1/links",
            type: "post",
            data: JSON.stringify(linkRequest),
            headers: requestHeaders,
            dataType: "json",
            success: (link) => {
                $("#text-link").text(link.shortUrl);
                $("#copy-btn").attr("data-clipboard-text", link.shortUrl);
                $(".modal-overlay").css("display", "none");
            },
            error: function(XMLHttpRequest, textStatus, errorThrown) {
                console.log("Status: " + textStatus);
                $("#text-link").text(encodeURI(longlink));
                $("#copy-btn").attr("data-clipboard-text", encodeURI(longlink));
                $(".modal-overlay").css("display", "none");
            }
        });
    });

    //save png
    $("#save-png").click(function() {
        var sku = $('#product-description-bottom > ul:nth-child(3) > li:nth-child(1)').text();
        api.commands.setCommandOptions('snapshot', {
            dataType: 'image',
            camera: null,
            width: '800',
            height: '800',
            name:'ProductImage',
        });
        var result = api.commands.runCommand('snapshot',{'fileName':sku});
        if (result) {
        }
        api.commands.setCommandOptions('snapshot', {
            camera: "Camera_Main",
            dataType: 'blob',
            width: 1024,
            height: 1024,
        });
    });



    //changing a swatch
    $(".bold_options").on("change", "input:checkbox", function(event) {

        var tempPublicName = $(this).parents(".bold_option_element").siblings(".bold_option_title").text();

        var attr = tempPublicName.replace("*", "").replace(/[0-9]/g, '').trim();

        if (this.checked) {
            $("#loading-overlay").css("display", "block");
            var val = this.value.trim().replace(/ *\[[^)]*\] */g, "");
            setTimeout(function() {
                var tempOBJ = new Object;
                tempOBJ[attr] = val;

                threekitQueue.push(tempOBJ);

                checkFlag();
            }, 0);
            boldOverwrite(attr, val);
        } else {


        }

        if (attr == "Product") {
         	if(val == "Beam Wrap - 4 Feet"){
       			boldOverwrite("Number of Pendants", "9");
              }
          
            if (val.includes("Wood Chandelier")) {
                boldOverwrite("Ceiling Plate", "Black");
                setTimeout(function() {
                    api.configuration.executeAttribute("Ceiling Plate", "Black");
                }, 0);
            }
        }
    });

    //changing a dropbox
    $(".bold_options").on("change", "select", function(event) {


       var tempPublicName = $(this).parents(".bold_option_element").prevAll(".bold_option_title:first").text();
        var val = this.options[this.selectedIndex].value;

        if (val) {
            $("#loading-overlay").css("display", "block");
            var attr = tempPublicName.replace("*", "").replace(/[0-9]/g, '').trim();
            setTimeout(function() {
                var tempOBJ = new Object;
                tempOBJ[attr] = val;
                threekitQueue.push(tempOBJ);
                checkFlag();
            }, 0);

            boldOverwrite(attr, val);
        }
    });


    $("#create-specsheet").click(function(e) {
        $("#specSheetModalOverlay").css("display", "none");
    });


    $("#export-fbx").click(function(e) {
        $("#export-response").html("");
        $(".loader-3dexport").css("display", "block");
        //var hashpromise = api.configuration.saveConfig().then(function(hash){
        // let xhr = new XMLHttpRequest();
        // let xhr1 = new XMLHttpRequest();
        //var sceneId = api.sceneIO.getSceneId();
        //console.log(hash);  
        //xhr1.open('POST', 'http://hangout-lighting.mythreekit.com/export/clara?sceneId='+sceneId +"&hash=" + hash);
        //xhr1.responseType = 'json';
        //xhr1.send();
        //xhr1.onload = setTimeout(function() {
        //  let responseObj = xhr1.response;
        //  var location = responseObj.location; 
        //  var inter = setInterval(checkStatus,5000);
        //  function checkStatus(){
        //      //set the request type to post and the destination url to '/convert'
        //    xhr.open('GET', 'http://hangout-lighting.mythreekit.com/export/result?location='+ location +"&hash=" + hash);
        //    //set the reponse type to blob since that's what we're expecting back
        //    xhr.responseType = 'json';
        //    xhr.send(); 
        //
        //xhr.onload = function () {
        //        if (xhr.response.status == 'ok' ) {
        //          console.log(xhr.response.fileUrl);
        //          
        //fetch(xhr.response.fileUrl)
        //  .then(resp => resp.blob())
        //  .then(blob => {
        //    const url = window.URL.createObjectURL(blob);
        //    const a = document.createElement('a');
        //   console.log(blob);
        //    a.style.display = 'none';
        //    a.href = url;
        //    // the filename you want
        //    a.download = '3dModel-MixMatch.zip';
        //    document.body.appendChild(a);
        //    a.click();
        //  })
        //  .catch(() => alert('oh no!'));
        api.configuration.generateFBX().then(function() {
            $(".loader-3dexport").css("display", "none");
            $("#export-response").html("Success!");
        });
        //        clearInterval(inter);
        //    } else if (xhr.response.status == 'failed'){
        //      $(".loader-3dexport").css("display","none");
        //     $("#export-response").html("Your download has failed.  Please contact: info@mixmatchlighting.com");
        //clearInterval(inter);
        //    } else {
        //      console.log(xhr.response.status);
        //}
        //};   
        //
        // }

        //},3000);




        // }); 



    });


    $("#specSheetForm button").click(function(e) {
        var isValid = true;
        var tempData = new Object;
        e.preventDefault(); //prevent the default action
        $(".form-field").each(function(index) {
            if ($(this).find("input").val()) {
                $(this).find("label").css("color", "unset");
            } else {
                $(this).find("label").css("color", "red");
            }
        });
        if ($("#Project").val()) {
            tempData["project"] = $("#Project").val();
        } else {
            isValid = false;
        }
        if ($("#Type").val()) {
            tempData["type"] = $("#Type").val();
        } else {
            isValid = false;
        }
        if ($("#Qty").val()) {
            tempData["qty"] = $("#Qty").val();
        } else {
            isValid = false;
        }
        if ($("#Email").val()) {
            tempData["createdBy"] = $("#Email").val();
            tempData["email"] = $("#Email").val();
        } else {
            isValid = false;
        }
        tempData["domain"] = "mixmatch";
        if (isValid) {
            $("#errorMessage").css("display", "none");
            if ($(this).is("#downloadSpecButton")) {

                api.configuration.generatePDF(tempData);
                $("#specSheetModalOverlay").css("display", "block");
            } else {
                api.configuration.sendEmail(tempData);
                $("#specSheetModalOverlay").css("display", "block");
            }
        } else {
            $("#errorMessage").css("display", "block");
        }

    });


$('#recenter-button').click(function(e) {
        //on submit -frame scene - save image with timestamp - add url to form
        var translation = {
            x: 0,
            y: .2,
            z: 1.5
        };
        var cameraId = api.player.getCamera();
        api.scene.set({
            id: cameraId,
            plug: 'Transform',
            property: 'translation'
        }, translation);
        api.player.frameScene();
  
});

});